var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    d: "M17.5 5.83268V14.166C17.5 16.666 16.25 18.3327 13.3333 18.3327H6.66667C3.75 18.3327 2.5 16.666 2.5 14.166V5.83268C2.5 3.33268 3.75 1.66602 6.66667 1.66602H13.3333C16.25 1.66602 17.5 3.33268 17.5 5.83268Z",
    fill: "#E8F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M15.4173 7.70833H13.7507C12.484 7.70833 11.459 6.68333 11.459 5.41667V3.75C11.459 3.40833 11.7423 3.125 12.084 3.125C12.4257 3.125 12.709 3.40833 12.709 3.75V5.41667C12.709 5.99167 13.1757 6.45833 13.7507 6.45833H15.4173C15.759 6.45833 16.0423 6.74167 16.0423 7.08333C16.0423 7.425 15.759 7.70833 15.4173 7.70833Z",
    fill: "#E8F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M9.99935 11.459H6.66602C6.32435 11.459 6.04102 11.1757 6.04102 10.834C6.04102 10.4923 6.32435 10.209 6.66602 10.209H9.99935C10.341 10.209 10.6243 10.4923 10.6243 10.834C10.6243 11.1757 10.341 11.459 9.99935 11.459Z",
    fill: "#E8F0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M13.3327 14.791H6.66602C6.32435 14.791 6.04102 14.5077 6.04102 14.166C6.04102 13.8243 6.32435 13.541 6.66602 13.541H13.3327C13.6743 13.541 13.9577 13.8243 13.9577 14.166C13.9577 14.5077 13.6743 14.791 13.3327 14.791Z",
    fill: "#E8F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.fe1c9ae37e69d1f411f6eede5bc2c623.svg";
export { ForwardRef as ReactComponent };